/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hours_HintInputs */

const en_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open daily, weather permitting.`)
};

const es_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abierto todos los días, según el clima.`)
};

const de_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täglich geöffnet, sofern das Wetter es zulässt.`)
};

const zh_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每天开放，视天气而定。`)
};

const ar_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مفتوح يومياً، حسب الطقس.`)
};

const fr_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvert tous les jours, si le temps le permet.`)
};

const vi_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở hàng ngày, tùy thời tiết.`)
};

const sw_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunafungua kila siku, hali ya hewa ikiruhusu.`)
};

const th_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดทุกวัน หากสภาพอากาศเอื้ออำนวย`)
};

const bs_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otvoreno svaki dan, ako vremenske prilike dozvole.`)
};

const ja_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日営業（天候による）。`)
};

const ko_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매일 운영 (날씨에 따라 변동)`)
};

const pt_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aberto todos os dias, se o tempo permitir.`)
};

const it_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperto tutti i giorni, tempo permettendo.`)
};

const sv_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öppet dagligen om vädret tillåter.`)
};

const nl_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijks geopend als het weer het toelaat.`)
};

const da_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åbent dagligt, hvis vejret tillader det.`)
};

const nb_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åpent daglig når været tillater det.`)
};

const fi_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoinna päivittäin sään salliessa.`)
};

const pl_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwarte codziennie, jeśli pozwala pogoda.`)
};

const ru_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыт ежедневно, если позволяет погода.`)
};

const tr_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her gün açık, hava koşulları elverdiğince.`)
};

const hi_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोज़ खुला, मौसम अनुकूल होने पर।`)
};

const id_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka setiap hari, jika cuaca memungkinkan.`)
};

const ms_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuka setiap hari, jika cuaca mengizinkan.`)
};

const cs_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřeno denně, pokud to počasí dovolí.`)
};

const el_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανοιχτό καθημερινά, εφόσον το επιτρέπει ο καιρός.`)
};

const he_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פתוח מדי יום, בכפוף למזג האוויר.`)
};

const af_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daagliks oop, as die weer dit toelaat.`)
};

const hu_contact_hours_hint = /** @type {(inputs: Contact_Hours_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naponta nyitva, ha az időjárás engedi.`)
};

/**
* | output |
* | --- |
* | "Open daily, weather permitting." |
*
* @param {Contact_Hours_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_hours_hint = /** @type {((inputs?: Contact_Hours_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hours_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_hours_hint(inputs)
	if (locale === "de") return de_contact_hours_hint(inputs)
	if (locale === "zh") return zh_contact_hours_hint(inputs)
	if (locale === "ar") return ar_contact_hours_hint(inputs)
	if (locale === "fr") return fr_contact_hours_hint(inputs)
	if (locale === "vi") return vi_contact_hours_hint(inputs)
	if (locale === "sw") return sw_contact_hours_hint(inputs)
	if (locale === "th") return th_contact_hours_hint(inputs)
	if (locale === "bs") return bs_contact_hours_hint(inputs)
	if (locale === "ja") return ja_contact_hours_hint(inputs)
	if (locale === "ko") return ko_contact_hours_hint(inputs)
	if (locale === "pt") return pt_contact_hours_hint(inputs)
	if (locale === "it") return it_contact_hours_hint(inputs)
	if (locale === "sv") return sv_contact_hours_hint(inputs)
	if (locale === "nl") return nl_contact_hours_hint(inputs)
	if (locale === "da") return da_contact_hours_hint(inputs)
	if (locale === "nb") return nb_contact_hours_hint(inputs)
	if (locale === "fi") return fi_contact_hours_hint(inputs)
	if (locale === "pl") return pl_contact_hours_hint(inputs)
	if (locale === "ru") return ru_contact_hours_hint(inputs)
	if (locale === "tr") return tr_contact_hours_hint(inputs)
	if (locale === "hi") return hi_contact_hours_hint(inputs)
	if (locale === "id") return id_contact_hours_hint(inputs)
	if (locale === "ms") return ms_contact_hours_hint(inputs)
	if (locale === "cs") return cs_contact_hours_hint(inputs)
	if (locale === "el") return el_contact_hours_hint(inputs)
	if (locale === "he") return he_contact_hours_hint(inputs)
	if (locale === "af") return af_contact_hours_hint(inputs)
	if (locale === "hu") return hu_contact_hours_hint(inputs)
	return en_contact_hours_hint(inputs)
});